import styled, { keyframes } from "styled-components";
import colors from "../../styles/colors";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: ${colors.background.gradient};
  padding: 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle at 30% 20%,
      ${colors.input.focusShadow} 0%,
      transparent 50%
    );
    pointer-events: none;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 24px;
  padding: 3rem 4rem;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.08),
    0 8px 25px rgba(0, 0, 0, 0.05);
  text-align: center;
  max-width: 480px;
  width: 100%;
  animation: ${fadeIn} 0.6s ease-out;
  position: relative;
  z-index: 1;

  @media (max-width: 520px) {
    padding: 2rem 1.5rem;
    border-radius: 16px;
  }
`;

export const Logo = styled.img`
  height: 120px;
  margin-bottom: 2rem;
`;

export const Title = styled.h1`
  font-family: "Poppins", "Segoe UI", sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  color: ${colors.text.title};
  margin: 0 0 0.75rem;
  line-height: 1.3;

  @media (max-width: 520px) {
    font-size: 1.5rem;
  }
`;

export const Subtitle = styled.p`
  font-family: "Poppins", "Segoe UI", sans-serif;
  font-size: 1rem;
  color: ${colors.text.subtitle};
  margin: 0 0 2rem;
  line-height: 1.6;
`;

export const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: ${colors.primary};
  color: ${colors.text.white};
  font-family: "Poppins", "Segoe UI", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 1rem 2rem;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px ${colors.loader.muted};
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Divider = styled.div`
  width: 60px;
  height: 4px;
  background: linear-gradient(
    90deg,
    ${colors.primaryLight},
    ${colors.primaryLightHover}
  );
  border-radius: 2px;
  margin: 0 auto 1.5rem;
`;
